export enum ExclusiveCategory {
  COLLECTIBLE = 'COLLECTIBLE',
  MOMENT = 'MOMENT',
  ACCESS = 'ACCESS',
}
